// extracted by mini-css-extract-plugin
export default {"crimeTitle":"CategoryDateCrimeListItem_crimeTitle__zVTSb","crimeCard":"CategoryDateCrimeListItem_crimeCard__oWEOu"};